module.exports = __webpack_public_path__ + "static/media/cq_contrassegna_elemento2 b.e1b7e96c.svg";